import enSurvey from './en';
import ruSurvey from './ru';

export default {
  en: {
    ...enSurvey,
  },
  ru: {
    ...ruSurvey,
  },
};
